import *  as React from 'react';

const SimulatorAccordion: React.FC = () => {
    const [openAccordionItem, setOpenAccordionItem] = React.useState(0);

    const toggleAccordion = (newItem: number) => {
        setOpenAccordionItem((activeItem: number) => activeItem !== newItem ? newItem : -1);
    };
    const items: { title: string, content: JSX.Element }[] = [
        {
            title: '¿Qué es Motorfy?',
            content:
                <p>
                    Motorfy es un servicio 100% online y seguro de inicio a fin que te permite comprar y buscar un
                    auto a crédito. Trabajamos con distintas financieras para ofrecer la mejor opción de crédito a
                    nuestros clientes y a través de nuestro inventario de vehículos, publicado por agencias y lotes
                    en nuestro portal, encontramos el auto que mejor se adapte a las necesidades de nuestros
                    clientes.
                </p>,
        },
        {
            title: '¿Dónde encuentro autos que aplican al financiamiento?',
            content: <p>
                Para revisar nuestro inventario de autos a crédito ingresa a seminuevos.com - sección autos
                usados - autos financiados. Sin embargo, si no encuentras el auto que deseas puedes aplicar al
                crédito y nosotros te ayudamos con la búsqueda de tu vehículo.
            </p>,
        },
        {
            title: '¿Cómo solicito crédito?',
            content: <p>
                Para hacer una solicitud de crédito debes ingresar a <a
                    href="https://mx.motorfy.com">https://mx.motorfy.com</a>, completar tus datos y los del auto de
                tu
                interés en la solicitud.
                Si tu solicitud es aprobada un asesor se pondrá en contacto contigo para continuar con el proceso.
            </p>,
        },
        {
            title: '¿Puedo obtener un financiamiento si tengo atrasos en mi historial crediticio?',
            content: <p>
                Si es posible sacar crédito si tu historial crediticio no es bueno. Contamos con opciones de
                crédito para distintos perfiles.
            </p>,
        },
        {
            title: '¿Puedo obtener financiamiento si no tengo historial crediticio?',
            content: <p>
                Si es posible sacar crédito si no tienes historial crediticio. Contamos con opciones de
                crédito para distintos perfiles.
            </p>,
        },
        {
            title: '¿Puedo obtener financiamiento si no puedo comprobar ingresos?',
            content: <p>
                Si es posible sacar crédito si no tienes como comprobar ingresos. Contamos con opciones de crédito
                para distintos perfiles.
            </p>,
        },
        {
            title: '¿Dónde se encuentran ubicados?',
            content: <p>
                Trabajamos en toda la República Mexicana, sin embargo, todo el proceso de crédito lo hacemos
                en línea. Por esto, si deseas adquirir un crédito debes ingresar una solicitud en <a
                href="https://mx.motorfy.com">https://mx.motorfy.com</a>
            </p>,
        },
        {
            title: '¿Cuáles son los requisitos para sacar un crédito con Motorfy?',
            content: <ul>
                <li>Credencial del INE</li>
                <li>Comprobante domicilio</li>
                <li>Comprobantes de ingresos (no en todos los casos)</li>
                <li>Tener 21 años cumplidos</li>
            </ul>,
        },
        {
            title: '¿Cuáles son las características del crédito?',
            content: <ul>
                <li>Desde 20% de enganche</li>
                <li>Hasta 48 meses de plazo</li>
                <li>Tasas desde 1.27% mensual</li>
                <li>Vehículos hasta 11 años de antigüedad</li>
                <li>Flexibilidad en el historial crediticio</li>
                <li>Pre aprobación inmediata</li>
                <li>Aprobación en menos de 48 horas</li>
            </ul>,
        },
        {
            title: '¿Qué incluye en nuestro servicio?',
            content: <ul>
                <li>Acompañamiento en el proceso de inicio a fin</li>
                <li>Seguro vehicular financiado o de contado</li>
                <li>Distintas opciones de crédito automotriz según el perfil del cliente</li>
                <li>Garantía mecánica en un auto seminuevo (costo adicional)</li>
                <li>Variedad de opciones de autos para elegir</li>
            </ul>,
        },
    ];
    return (
        <div className="accordion accordion--faqs">
            {items.map((item, index) =>
                <div key={index} className={`accordion-item ${openAccordionItem === index ? 'active' : ''}`}>
                    <div className="accordion-head"
                         onClick={() => toggleAccordion(index)}
                         id={`accordionItem${index}`}>
                        <h2 className="accordion-title">{item.title}</h2>
                    </div>
                    <div className="accordion-content">{item.content}</div>
                </div>
            )}
        </div>
    );
};

export default SimulatorAccordion;